import { links } from '../../router/links';
import { useAppSelector } from '../../redux/hooks';
import { HelpPageContent, HelpPageDataFetcher } from '../../components';
import { useTypedTranslation } from '../../i18n/i18n';

export const FileDashboardHelpView = () => (
  <HelpPageDataFetcher pageName="fileDashboardHelpPage">
    <FileDashboardHelpViewContent />
  </HelpPageDataFetcher>
);

const FileDashboardHelpViewContent = () => {
  const { t } = useTypedTranslation();
  const content = useAppSelector(state => state.content.help.content.fileDashboardHelpPage);

  return <HelpPageContent content={content} backLabel={t('common.back')} backToLink={links.fileDashboard} />;
};
